/* Release 6.2 product pages, full spec (03_Spec_Release_6_2_Product_Pages.md).
   Deferred, loaded from sections/av-pdp-worldclass-main-v3.liquid only with the
   r62_layout switch on, on product.av-granola and product.av-portable.
   1. Gallery: thumbnails are buttons with aria-pressed; a click or Enter shows
      that frame and sends pdp_gallery_select (index, role).
   2. Quantity: granola tiles and the bar stepper set the native quantity input
      of the product form (au-purchase owns the add); tiles send
      pdp_multipack_click. The free shipping line follows the quantity.
   3. CEP: the state comes from the CEP by the Correios ranges, so the existing
      estimator (av-v53-release-runtime.js) needs no state dropdown.
   4. Reviews: one request to the Loox storefront API the aureviews section uses.
      Up to three short quotes in the strip, the lowest rated short review always
      among them, cut at 160 characters (au-qa D2), inserted only while the strip
      is off screen (au-qa D3). The photo wall takes customer photos only and
      stays hidden under four.
   5. Questions send pdp_faq_open (index); the next purchase cards send
      pdp_next_add (handle) once au-purchase confirms the add; links marked
      data-au-r62-event send their event with target and source. */
(() => {
  if (window.AUR62Pdp) return;
  const track = (event, payload = {}) => { try { window.AVAnalytics?.custom?.(event, payload); } catch (_) { /* analytics are optional */ } };
  const money = (cents) => {
    try { if (window.theme?.formatMoney) { const s = document.createElement('span'); s.innerHTML = window.theme.formatMoney(Number(cents), window.theme.moneyFormat); return s.textContent; } } catch (_) { /* fall through */ }
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(cents) / 100);
  };

  /* 1. Gallery */
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-au-r62-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-au-r62-gallery]');
    const n = thumb.dataset.auR62Thumb;
    gallery.querySelectorAll('[data-au-r62-frame]').forEach((frame) => { frame.hidden = frame.dataset.auR62Frame !== n; });
    gallery.querySelectorAll('[data-au-r62-thumb]').forEach((t) => t.setAttribute('aria-pressed', String(t === thumb)));
    track('pdp_gallery_select', { index: Number(n), role: thumb.dataset.role || '' });
  });
  // On phone the thumbnails are hidden and the frames scroll sideways: the strip
  // takes focus so the arrow keys reach every photo (au-qa N10).
  const phone = window.matchMedia('(max-width: 767px)');
  const stageFocus = () => document.querySelectorAll('[data-au-r62-stage]').forEach((stage) => {
    if (phone.matches) { stage.tabIndex = 0; stage.setAttribute('role', 'region'); stage.setAttribute('aria-label', stage.dataset.label || ''); }
    else { stage.removeAttribute('tabindex'); stage.removeAttribute('role'); stage.removeAttribute('aria-label'); }
  });
  stageFocus();
  if (phone.addEventListener) phone.addEventListener('change', stageFocus);

  // On phone the review cards scroll sideways: a control that takes focus in a
  // card half off screen brings its card into view (au-qa R10).
  document.addEventListener('focusin', (event) => {
    const grid = event.target.closest?.('.au-r62-reviews .av-reviews-editorial__grid');
    if (!grid || event.target === grid || grid.scrollWidth <= grid.clientWidth) return;
    const card = [...grid.children].find((child) => child.contains(event.target));
    if (card) card.scrollIntoView({ inline: 'start', block: 'nearest' });
  });

  /* 2. Quantity and the free shipping line */
  const setQuantity = (inputId, quantity) => {
    const input = document.getElementById(inputId);
    if (!input) return;
    input.value = String(quantity);
    input.setAttribute('value', String(quantity));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const ship = document.querySelector('[data-au-r62-ship]');
    if (!ship) return;
    const target = Number(ship.dataset.target) || 0;
    const total = (Number(ship.dataset.cart) || 0) + (Number(ship.dataset.price) || 0) * quantity;
    const left = Math.max(0, target - total);
    const line = ship.querySelector('[data-au-r62-ship-line]');
    if (line) line.textContent = left > 0 ? (ship.dataset.template || '').replace('[[amount]]', money(left)) : ship.dataset.done || '';
    const fill = ship.querySelector('[data-au-r62-ship-fill]');
    if (fill && target > 0) fill.style.width = `${Math.min(100, Math.floor((total * 100) / target))}%`;
  };
  document.addEventListener('click', (event) => {
    const tile = event.target.closest('[data-au-r62-qty-set]');
    if (tile) {
      const box = tile.closest('[data-au-r62-qty]');
      const quantity = Number(tile.dataset.auR62QtySet) || 1;
      box.querySelectorAll('[data-au-r62-qty-set]').forEach((t) => t.setAttribute('aria-pressed', String(t === tile)));
      setQuantity(box.dataset.input, quantity);
      track('pdp_multipack_click', { quantity });
      return;
    }
    const step = event.target.closest('[data-au-r62-step]');
    if (step) {
      const box = step.closest('[data-au-r62-stepper]');
      const count = box.querySelector('[data-au-r62-count]');
      const max = Math.max(1, Number(box.dataset.max) || 1);
      const next = Math.min(max, Math.max(1, (Number(count.textContent) || 1) + Number(step.dataset.auR62Step)));
      count.textContent = String(next);
      box.querySelector('[data-au-r62-step="-1"]').disabled = next <= 1;
      box.querySelector('[data-au-r62-step="1"]').disabled = next >= max;
      setQuantity(box.dataset.input, next);
    }
  });

  /* 3. CEP: the state from the Correios ranges (first five digits). */
  const RANGES = [
    ['SP', 1000, 19999], ['RJ', 20000, 28999], ['ES', 29000, 29999], ['MG', 30000, 39999], ['BA', 40000, 48999],
    ['SE', 49000, 49999], ['PE', 50000, 56999], ['AL', 57000, 57999], ['PB', 58000, 58999], ['RN', 59000, 59999],
    ['CE', 60000, 63999], ['PI', 64000, 64999], ['MA', 65000, 65999], ['PA', 66000, 68899], ['AP', 68900, 68999],
    ['AM', 69000, 69299], ['RR', 69300, 69399], ['AM', 69400, 69899], ['AC', 69900, 69999], ['DF', 70000, 72799],
    ['GO', 72800, 72999], ['DF', 73000, 73699], ['GO', 73700, 76799], ['RO', 76800, 76999], ['TO', 77000, 77999],
    ['MT', 78000, 78899], ['MS', 79000, 79999], ['PR', 80000, 87999], ['SC', 88000, 89999], ['RS', 90000, 99999]
  ];
  const stateFor = (digits) => {
    if (digits.length !== 8) return '';
    const head = Number(digits.slice(0, 5));
    const hit = RANGES.find(([, from, to]) => head >= from && head <= to);
    return hit ? hit[0] : '';
  };
  document.querySelectorAll('[data-au-r62-cep]').forEach((form) => {
    const input = form.querySelector('[data-au-r62-cep-input]');
    const province = form.querySelector('[name="province"]');
    const fill = () => { const digits = (input.value || '').replace(/\D/g, '').slice(0, 8); province.value = stateFor(digits); return digits; };
    input.addEventListener('input', () => {
      const digits = fill();
      const shown = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      if (input.value !== shown) input.value = shown;
    });
    // Runs on the form before the estimator's document listener reads the state.
    form.addEventListener('submit', () => { fill(); });
  });

  /* 4. Reviews: quotes in the strip and the photo wall, one request. */
  const make = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text != null) el.textContent = text; return el; };
  const strip = document.querySelector('[data-au-r62-strip]');
  const wall = document.querySelector('[data-au-r62-photos]');
  const source = strip || wall;
  const fetchReviews = async () => {
    if (!source?.dataset.storeId || !source.dataset.productId) return [];
    const url = new URL(`https://storefront-api.loox.io/storefront/v1/store/${encodeURIComponent(source.dataset.storeId)}/product-reviews`);
    url.searchParams.set('sort', 'date');
    url.searchParams.set('direction', 'desc');
    url.searchParams.set('limit', '60');
    url.searchParams.set('page', '1');
    url.searchParams.set('product_id', source.dataset.productId);
    if (source.dataset.locale) url.searchParams.set('locale', source.dataset.locale);
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'omit' });
      if (!response.ok) return [];
      const data = await response.json();
      return Array.isArray(data?.reviews) ? data.reviews : [];
    } catch (_) { return []; }
  };
  // Adds content only while its place is off screen, so nothing moves under the
  // reader (au-qa D3, N9). Above the reader, browsers without scroll anchoring
  // (Safari) get the page moved back by the height added.
  const revealOffScreen = (anchor, show) => {
    const apply = () => {
      const above = anchor.getBoundingClientRect().bottom <= 0;
      const before = document.documentElement.scrollHeight;
      show();
      if (above && !(window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto'))) window.scrollBy(0, document.documentElement.scrollHeight - before);
    };
    const box = anchor.getBoundingClientRect();
    if (!('IntersectionObserver' in window) || box.top >= window.innerHeight || box.bottom <= 0) { apply(); return; }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => !entry.isIntersecting)) { observer.disconnect(); apply(); }
    });
    observer.observe(anchor);
  };
  const fillQuotes = (reviews) => {
    const list = strip?.querySelector('[data-au-r62-quotes]');
    if (!list) return;
    const all = reviews.map((review) => ({
      body: typeof review?.body === 'string' ? review.body.replace(/\s+/g, ' ').trim() : '',
      rating: Math.round(Number(review?.rating) || 0),
      name: String(review?.reviewer?.name || '').trim().split(' ')[0],
      verified: review?.verified === true
    })).filter((r) => r.body.length >= 20 && r.rating >= 1 && r.rating <= 5);
    const short = all.filter((r) => r.body.length <= 160);
    const pick = [];
    const names = new Set();
    for (const r of short) {
      if (pick.length >= 3) break;
      if (r.name && names.has(r.name)) continue;
      pick.push(r); if (r.name) names.add(r.name);
    }
    // The honesty rule: the lowest rated review below five stars is always shown.
    const lower = all.filter((r) => r.rating < 5);
    if (lower.length) {
      const lowest = lower.reduce((a, b) => (b.rating < a.rating ? b : a));
      if (!pick.some((r) => r.rating === lowest.rating && r.rating < 5)) {
        const cut = lowest.body.length > 160 ? `${lowest.body.slice(0, 159).replace(/\s+\S*$/, '')}…` : lowest.body;
        pick.splice(Math.min(pick.length, 2), pick.length >= 3 ? 1 : 0, { ...lowest, body: cut });
      }
    }
    if (!pick.length) return;
    const scale = (strip.dataset.copyRating || '');
    for (const r of pick) {
      const item = make('li', 'au-r62-quote');
      const rating = make('p', 'au-r62-quote__rating');
      rating.appendChild(make('span', '', (strip.dataset.copyLabel || '').replace('[[rating]]', String(r.rating)))).setAttribute('aria-hidden', 'true');
      rating.appendChild(make('span', 'visually-hidden', scale.replace('[[rating]]', String(r.rating))));
      item.appendChild(rating);
      const quote = make('blockquote', 'au-r62-quote__text');
      quote.appendChild(make('p', '', `“${r.body}”`));
      item.appendChild(quote);
      const meta = [r.name, r.verified ? strip.dataset.copyVerified : ''].filter(Boolean).join(' · ');
      if (meta) item.appendChild(make('p', 'au-r62-quote__meta', meta));
      list.appendChild(item);
    }
    revealOffScreen(strip, () => { list.hidden = false; });
  };
  const fillWall = (reviews) => {
    if (!wall) return;
    const photos = [];
    for (const review of reviews) {
      const media = Array.isArray(review?.media) ? review.media : [];
      const photo = media.find((m) => m && ['photo', 'image'].includes(String(m.type || '').toLowerCase()) && typeof m.url === 'string' && m.url.startsWith('https://'));
      if (photo) photos.push(photo.url.replace(/_orig\.(jpe?g|png|webp)$/i, '.$1'));
      if (photos.length >= 6) break;
    }
    if (photos.length < 4) return;
    for (const src of photos) {
      const li = make('li');
      const img = make('img');
      img.src = src; img.alt = wall.dataset.alt || ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 300; img.height = 300;
      li.appendChild(img);
      wall.appendChild(li);
    }
    // The wall opens just above the reviews button; wait until that place is off screen.
    const anchor = wall.nextElementSibling || wall.parentElement;
    revealOffScreen(anchor, () => { wall.hidden = false; });
  };
  if (source) {
    const run = async () => { const reviews = await fetchReviews(); fillQuotes(reviews); fillWall(reviews); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 4000 });
    else window.setTimeout(run, 1500);
  }

  /* 5. Questions, next purchase, marked links */
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (item?.matches?.('[data-au-r62-faq]') && item.open) track('pdp_faq_open', { index: Number(item.dataset.auR62Faq) });
  }, true);
  document.addEventListener('australia:purchase_confirmed', (event) => {
    const card = event.target?.closest?.('[data-au-r62-next-handle]');
    if (card) track('pdp_next_add', { handle: card.dataset.auR62NextHandle });
  });
  document.addEventListener('click', (event) => {
    const node = event.target.closest('[data-au-r62-event]');
    if (!node) return;
    const payload = {};
    if (node.dataset.auR62Target) payload.target = node.dataset.auR62Target;
    if (node.dataset.auR62Source) payload.source = node.dataset.auR62Source;
    track(node.dataset.auR62Event, payload);
  });

  window.AUR62Pdp = Object.freeze({ version: '2.0' });
})();
